import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Cursor IDE for software development" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <h2 className="title">Cursor IDE</h2>

        <div className="mt-8">
          <h3 className="text-2xl font-semibold mb-4">Development</h3>
          <div className="space-y-2">
            <p>• Agentic AI-ondersteunde programmering</p>
            <p>• Alle AI modellen in één IDE</p>
            <p>• Git versiebeheer</p>
          </div>
        </div>
      </div>
    </Slide>
  );
};
